var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.classList
  }, [_c('span', {
    staticClass: "title-text-style",
    class: {
      'title-text-style-new': _vm.fullView
    }
  }, [_vm._v(_vm._s(_vm.title))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };